import http from '@/http';
import httpNova from '../httpNovoEndpoint';

export default {

    list() {
        return http.get('/offices');
    },
    get(id) {
        return http.get(`/offices/${id}`);
    },
    save(form) {
        return http.post('/offices', form);
    },
    update(id, form) {
        return http.put(`/offices/${id}`, form);
    },
    getEvaluateOffices() {
        const ret = httpNova.get(`/Secretarias/avaliacaoScore`);
        return ret;
    },
};


// WEBPACK FOOTER //
// ./src/api/offices.js